export const ROADMAP_STATUS_OPTIONS = Object.freeze([
  { id: "Planejado", name: "Planejado" },
  { id: "Em Andamento", name: "Em Andamento" },
  { id: "Concluído", name: "Concluído" },
  { id: "Em Atraso", name: "Em Atraso" },
]);

export const ROADMAP_STATUS_EM_ATRASO = "Em Atraso";
export const ROADMAP_STATUS_CONCLUIDO = "Concluído";
